
import Vue from 'vue';

export default Vue.extend({
  name: 'Variation',
  props: {
    liteDisplay: {
      type: Boolean,
      default: false
    },
    value: {
      type: Number,
      default: 0
    }
  },
  computed: {
    variationColor (): string {
      if (this.value > 0) {
        return 'error';
      } else if (this.value < 0) {
        return 'primary';
      } else {
        return 'warning';
      }
    },
    variationIcon (): string {
      if (this.value > 0) {
        return 'arrow-top-right';
      } else if (this.value < 0) {
        return 'arrow-bottom-right';
      } else {
        return 'arrow-right';
      }
    }
  }
});
